import 'dotenv/config';
import { superTeacherAccesses, subjectManagerAccesses, instructorAccesses, AccessList } from './accessList';
import StorageManager from '../helpers/storageManager';
import { localStorageLanguageKey } from './i18n/languages';

/* Adres serwera */
const apiUrl: string = process.env.REACT_APP_API_URL ? process.env.REACT_APP_API_URL : 'https://gateway.ms.p.lodz.pl/';

// Domena cookies
const cookiesDomain: string = process.env.REACT_APP_COOKIES_DOMAIN_URL ? process.env.REACT_APP_COOKIES_DOMAIN_URL : '.p.lodz.pl';

/* Adres panelu admina */
const adminPanelUrl: string = process.env.REACT_APP_ADMIN_PANEL_URL
  ? process.env.REACT_APP_ADMIN_PANEL_URL
  : 'https://ztn.p.lodz.pl/admin';

/* Adres serwisu uwierzytelniejącego */
const authServiceUrl: string = process.env.REACT_APP_AUTH_URL ? process.env.REACT_APP_AUTH_URL : 'https://mfa.p.lodz.pl';

/* Strona poprawnego wylogowania z CAS */
const casLogoutUrl = process.env.REACT_APP_CAS_LOGOUT_URL
  ? process.env.REACT_APP_CAS_LOGOUT_URL
  : 'https://login.p.lodz.pl/logout';

/* czas, po którym następuje synchronizacja danych z cache w milisekundach */
const cacheSyncRefreshTime = 900000;
/*
  Określenie języka aplikacji - jeśli zapisany jest w local Storage
  - pobierany jest stamtądFcon, jeśli nie ma takiej informacji - domyślnym językiem jest polski
 */
const defaultLanguage: string = StorageManager ? (StorageManager.get(localStorageLanguageKey) || 'pl').substring(0, 2) : 'pl';

interface RoleList {
  [key: string]: Role;
}
export interface Role {
  id: number;
  accessList: AccessList;
  translationKey: string;
}

/* Lista roli */
const roles: RoleList = {
  SUPERTEACHER: {
    // supernauczyciel
    id: 0,
    accessList: superTeacherAccesses,
    translationKey: 'ROLE_SUPERTEACHER',
  },
  SUBJECTMANAGER: {
    // kierownik przedmiotu
    id: 1,
    accessList: subjectManagerAccesses,
    translationKey: 'ROLE_SUBJECT_MANAGER',
  },
  INSTRUCTOR: {
    // wykładowca
    id: 2,
    accessList: instructorAccesses,
    translationKey: 'ROLE_INSTRUCTOR',
  },
};

interface EnvironmentList {
  [key: string]: Environment;
}

type Environment = 'local' | 'development' | 'stage' | 'production';

const environments: EnvironmentList = {
  LOCAL: 'local',
  DEVELOPMENT: 'development',
  STAGE: 'stage',
  PRODUCTION: 'production',
};

export {
  apiUrl,
  adminPanelUrl,
  authServiceUrl,
  defaultLanguage,
  roles,
  casLogoutUrl,
  cookiesDomain,
  cacheSyncRefreshTime,
  environments,
};
